<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn
          color="darkColor"
          small
          ref="yes"
          rounded
          class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white"
          @click="confirmDialogConfirmFunction()"
          :disabled="disabelConfirm"
        >
          بله
        </v-btn>
        <v-btn
          small
          rounded
          text
          ref="no"
          class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()"
        >
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="currentUserChangePasswordModal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-key</v-icon>
              <span class="modal-title-text mr-2">تغییر کلمه عبور</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                prepend-inner-icon="mdi-key mdi-18px"
                label="کلمه عبور قبلی"
                v-model="currentPassword"
                clearable
                clear-icon="mdi-close-circle-outline"
                :type="currentPasswordClass"
                :append-icon="currentPasswordIcon"
                @click:append="showCurrentPassword()"
                v-on:keyup.enter="login()"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                prepend-inner-icon="mdi-key mdi-18px"
                label="کلمه عبور جدید"
                v-model="newPassword"
                clearable
                clear-icon="mdi-close-circle-outline"
                :type="newPasswordClass"
                :append-icon="newPasswordIcon"
                @click:append="showNewPassword()"
                v-on:keyup.enter="login()"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                prepend-inner-icon="mdi-key mdi-18px"
                label="تکرار کلمه عبور جدید"
                v-model="newPasswordRepeat"
                clearable
                clear-icon="mdi-close-circle-outline"
                :type="newPasswordRepeatClass"
                :append-icon="newPasswordRepeatIcon"
                @click:append="showNewPasswordRepeat()"
                v-on:keyup.enter="login()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            @click="showConfirmDialogFunction()"
            dark
            rounded
            class="normal-letter-spacing px-12"
          >
            ثبت
          </v-btn>
          <v-btn
            rounded
            color="darkColor"
            outlined
            @click="cancelChangePassword()"
            class="normal-letter-spacing px-10"
          >
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editCurrentUserModal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-pencil</v-icon>
              <span class="modal-title-text mr-2">ویرایش اطلاعات</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                type="text"
                outlined
                id="user-brithDate"
                ref="dateTimeAdd"
                dense
                v-model="tempCurrentUserDate"
                @focus="showCurrentUserDate = true"
                @click="showCurrentUserDate = true"
                label="تاریخ تولد"
                prepend-inner-icon="mdi-calendar-range mdi-18px"
              >
                <template slot="append">
                  <v-icon
                    @click="showCurrentUserDate = true"
                    class="calender-background ml-n3 mt-n2"
                    color="white"
                  >
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker
                :show="showCurrentUserDate"
                simple
                @change="currentUserDateChange()"
                :editable="true"
                format="YYYY-MM-DD"
                v-model="userProfile.birthDate"
                display-format="jYYYY/jMM/jDD"
                custom-input="#userr1-brithDate"
                @close="showCurrentUserDate = false"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="text"
                v-model="userProfile.phoneNumber"
                dense
                outlined
                v-on:keyup.enter="showConfirmDialogFunction()"
                label="شماره همراه"
                clearable
                clear-icon="mdi-close-circle-outline"
                class="input-label"
                prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="text"
                v-model="userProfile.address"
                dense
                outlined
                v-on:keyup.enter="showConfirmDialogFunction()"
                label="آدرس"
                clearable
                clear-icon="mdi-close-circle-outline"
                class="input-label"
                prepend-inner-icon="mdi-map-marker mdi-18px"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="text"
                v-model="userProfile.emailAddress"
                dense
                outlined
                v-on:keyup.enter="showConfirmDialogFunction()"
                label="ایمیل"
                clearable
                clear-icon="mdi-close-circle-outline"
                class="input-label"
                prepend-inner-icon="mdi-email mdi-18px"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            @click="showConfirmDialogFunction()"
            dark
            rounded
            class="normal-letter-spacing px-12"
          >
            ثبت
          </v-btn>
          <v-btn
            rounded
            color="darkColor"
            outlined
            @click="cancelEditCurrentUser()"
            class="normal-letter-spacing px-10"
          >
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="circle" v-if="tab == 1"></div>
    <div class="white-space" v-if="tab == 1"></div>
    <div class="img-div" v-if="tab == 1">
      <div class="edit-img-div">
        <div class="blue-space">
          <v-file-input
            hide-input
            prepend-icon="mdi-pencil mdi-18px"
            class="edit-img-pen"
            dark
            v-model="img"
            @change="uploadImagefunction()"
          ></v-file-input>
        </div>
      </div>
      <v-img
        class="user-img"
        :src="'data:image/png;base64,' + userImage"
        v-if="hasImg"
        height="10vh"
        width="10vh"
      ></v-img>
      <v-icon v-else class="no-img" color="black">mdi-account-tie mdi-48px</v-icon>
    </div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">پروفایل</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="4" class="mr-10 mt-3">
              <v-row>
                <v-col cols="6">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-row>
                        <v-spacer></v-spacer>
                        <span @click="changeTab(1)" :class="profileClass">پروفایل</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="mr-n3">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-row>
                        <v-spacer></v-spacer>
                        <span @click="changeTab(2)" :class="accessClass">سوابق دسترسی</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-4">
            <v-col cols="12">
              <v-card height="73vh" elevation="0" class="body-card card-width">
                <v-card-text class="mt-3">
                  <v-row v-if="tab == 1">
                    <v-col cols="12">
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="11">
                          <v-row>
                            <v-col cols="2"></v-col>
                            <v-col cols="10">
                              <v-card height="60vh" elevation="0" class="show-data-card body-card">
                                <v-card-text>
                                  <v-row>
                                    <v-spacer></v-spacer>
                                    <v-col cols="11">
                                      <v-row>
                                        <v-col
                                          v-for="item in informationItem"
                                          :key="item.id"
                                          :cols="item.cols"
                                        >
                                          <user-detail-component
                                            :icon="item.icon"
                                            :size="item.size"
                                            :text="item.text"
                                            :title="item.title"
                                          ></user-detail-component>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-row class="mt-6">
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                  <v-btn
                                    @click="showEditPasswordModal()"
                                    rounded
                                    dark
                                    color="darkColor"
                                    block
                                    small
                                    class="normal-letter-spacing"
                                  >
                                    <v-icon color="white" class="ml-3">mdi-key mdi-18px</v-icon>
                                    تغییر کلمه عبور
                                  </v-btn>
                                </v-col>
                                <v-col cols="2">
                                  <v-btn
                                    @click="showEditCurrentUserModal()"
                                    rounded
                                    dark
                                    color="darkColor"
                                    block
                                    small
                                    class="normal-letter-spacing"
                                  >
                                    <v-icon color="white" class="ml-3">mdi-pencil mdi-18px</v-icon>
                                    ویرایش اطلاعات
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="tab == 2">
                    <v-col cols="12" class="text-center">
                      <v-card height="38vh" class="history-main-card2">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" v-for="(item, index) in userLoginInfo" :key="index">
                              <v-card height="8vh" elevation="0" class="attempt-items">
                                <v-card-text>
                                  <v-row>
                                    <v-col cols="5" class="mt-3">
                                      <v-row>
                                        <v-icon color="iconColor">
                                          mdi-calendar-blank-outline mdi-18px
                                        </v-icon>
                                        <span class="attempt-title mr-3">تاریخ:</span>
                                        <span class="mr-2 attempt-value">{{ item.date }}</span>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="5" class="mt-3">
                                      <v-row>
                                        <v-icon color="iconColor">
                                          mdi-calendar-blank-outline mdi-18px
                                        </v-icon>
                                        <span class="attempt-title mr-3">آی پی:</span>
                                        <span class="mr-2 attempt-value">{{ item.ip }}</span>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="2" class="mt-3">
                                      <v-row>
                                        <v-spacer></v-spacer>
                                        <span class="attempt-title">{{ item.successText }}</span>
                                        <v-spacer></v-spacer>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-card height="30vh" class="history-main-card mt-4">
                        <v-card-text>
                          <v-row>
                            <v-col cols="6" v-for="(item, index) in attemptInfo" :key="index">
                              <user-detail-component
                                :title="item.title"
                                :text="item.value"
                                :icon="item.icon"
                                :size="item.size"
                              ></user-detail-component>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import confirmDialog from '../components/ConfirmDialog.vue';
  import AlertComponent from '../components/AlertComponent.vue';
  import UserDetailComponent from '@/components/UserDetailComponent.vue';

  import ProfileHelper from '@/Helpers/ProfileHelper';

  import snackBar from '@/Mixins/snackBar.js';
  import Shared from '@/Mixins/Shared';
  import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
  export default {
    name: 'UserProfile',
    title: 'پروفایل',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      confirmDialog,
      AlertComponent,
      UserDetailComponent,
    },
    mixins: [snackBar, ProfileHelper, Shared, UserMixin],
    created() {
      this.$root.$refs.UserProfile = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {
        this.getUserProfileFunction();
      },
    },
  };
</script>
<style scoped>
  .modal-header {
    border-bottom: 2px solid var(--modal-border-color);
    border-bottom-right-radius: 12px !important;
    border-bottom-left-radius: 12px !important ;
  }
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .modal-title-text {
    color: var(--dark-color);
    font-weight: 500;
    font-size: 16px;
  }
  .body-card {
    overflow-y: auto !important;
  }

  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
  .active-tab {
    color: var(--dark-color) !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border-bottom: 2px solid var(--dark-color) !important;
    border-radius: none !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    color: var(--dark-color) !important;
    font-weight: 550 !important;
    letter-spacing: normal !important;
  }
  .text-style {
    cursor: pointer !important;
  }
  .show-data-card {
    border: 4px solid #eef6ff !important;
    border-radius: 15px !important;
  }
  .circle {
    position: absolute;
    height: 13vh !important;
    width: 13vh !important;
    border-radius: 50% !important;
    border: 4px solid #eef6ff !important;
    background: white;
    z-index: 9 !important;
    top: 30%;
    right: 18.2%;
  }
  .white-space {
    position: absolute;
    background: white !important;
    z-index: 9 !important;
    width: 13vh !important;
    height: 13.5vh !important;
    top: 30%;
    right: 15.1%;
  }
  .no-img {
    margin-right: 2.5vh;
    margin-top: 2vh;
  }
  .img-div {
    position: absolute;
    height: 12vh;
    width: 12vh;
    top: 30.5%;
    right: 14.2%;
    border-radius: 50% !important;
    border: 4px solid var(--dark-color) !important;
    z-index: 999999999999999 !important;
  }

  .edit-img-div {
    position: absolute;
    margin-top: 7vh;
    background: white !important;
    height: 5vh;
    width: 5vh;
    border-radius: 50% !important;
    z-index: 999999;
  }
  .blue-space {
    position: absolute;
    background: var(--dark-color) !important;
    margin-top: 0.5vh !important;
    margin-right: 0.5vh !important;
    height: 4vh;
    width: 4vh;
    border-radius: 50% !important;
    cursor: pointer;
  }
  .edit-img-pen {
    margin-right: 0.5vh !important;
    margin-top: -1.6vh !important;
  }
  .user-img {
    border-radius: 50% !important;
    margin-right: 0.5vh !important;
    margin-top: 0.5vh !important;
  }
  >>> .password .v-text-field__slot {
    font-family: 'password' !important;
  }
  .calender-background {
    background: #79747e;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }
  .history-main-card {
    border-radius: 15px !important;
  }
  .history-main-card2 {
    border-radius: 15px !important;
    overflow-y: auto !important;
  }
  .attempt-items {
    border-right: 2px solid var(--dark-color) !important;
    border-left: 2px solid var(--dark-color) !important;
    border-top: 2px solid var(--background-color) !important;
    border-bottom: 2px solid var(--background-color) !important;
    border-radius: 12px !important;
  }
  .attempt-title {
    color: #272727 !important;
    font-weight: 600;
    font-size: 14px;
  }
  .attempt-value {
    color: #272727 !important;
    font-weight: 400;
    font-size: 13px;
  }
</style>
